"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function on(element, eventName, callback, options) {
    element.addEventListener(eventName, callback, options);
    return function () { return element.removeEventListener(eventName, callback, options); };
}
exports.on = on;
//# sourceMappingURL=on.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/utilities/lib-commonjs/dom/on.js
// module id = 537
// module chunks = 0